<template>
  <div class="fillSpace centeredText clickable" @click="go()" id="fillSpace">
    <div class="title">
      <h2>{{ title }}</h2>
      <h1>{{ subtitle }}</h1>
    </div>
    <img class="bg-image" v-if="image" :src="imagePath" id="imageId" />
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'href', 'image', 'imageClasses'],
  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
  },
  methods: {
    go() {
      this.$router.push(this.href).catch(err => {
        this.$log.error(err);
      });
    },
  },
};
</script>

<style scoped>
.imageContainer {
  position: relative;
  width: 100%;
  height: 100%;
}

.imageContainer2 {
  position: relative;
  width: 100%;
  height: 100%;
}

.fillSpace {
  height: 100%;
  width: 100%;
}

img.bg-image {
  position: absolute;
  position: absolute;
  transition: transform 0.5s; /* Animation */
}

.title {
  position: absolute;
  transition: transform 0.5s; /* Animation */
}

.title h1 {
  font-size: 34px;
}

.title h2 {
  font-size: 32px;
}

.fillSpace:hover > .title {
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.fillSpace:hover > .bg-image {
  transform: scale(0.8); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.first .title {
  bottom: -78px;
  z-index: 1;
  left: 10%;
  right: 10%;
}

.second .title {
  bottom: -78px;
  left: 20%;
  right: 20%;
}

.third .title {
  bottom: -78px;
  left: 20%;
  right: 20%;
}

.first img {
  max-height: 100%;
  max-width: 80%;
  right: 9%;
  bottom: 0%;
}

.second img {
  max-width: 80%;
  max-height: 80%;
  top: 10%;
  left: 10%;
  right: 10%;
  margin: auto;
}

.third img {
  max-width: 80%;
  max-height: 80%;
  top: 10%;
  left: 10%;
  right: 10%;
  margin: auto;
}

h1 {
  font-size: 36px;
  line-height: 40px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  white-space: nowrap;
}

.clickable {
  cursor: pointer;
}
</style>
